module.exports = __webpack_public_path__ + "static/media/JAI03.79035a4d.jpg";